import { skipToken, useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type { EmailDraft } from '@erp/rpc';

/**
 * Hook to fetch an email draft by ID
 */
export function useEmailDraft(id: string | undefined, enabled = true) {
  const query = useQuery({
    ...orpc.communications.emailDrafts.get.queryOptions({
      input: id ? { id } : skipToken,
    }),
    enabled: Boolean(id) && enabled,
  });

  return {
    ...query,
    draft: query.data ?? null,
  } satisfies typeof query & {
    data?: EmailDraft | null;
    draft: EmailDraft | null;
  };
}
